/**
 * Secure Storage Utility
 * Provides secure storage for sensitive data with encryption
 */

import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.REACT_APP_STORAGE_KEY || 'default-key-change-in-production';

/**
 * Encrypt data before storing
 */
const encrypt = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString();
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

/**
 * Decrypt data after retrieval
 */
const decrypt = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

/**
 * Secure storage wrapper
 */
const secureStorage = {
  /**
   * Set item in secure storage
   */
  setItem: (key, value) => {
    try {
      const encrypted = encrypt(value);
      if (encrypted) {
        sessionStorage.setItem(key, encrypted);
        return true;
      }
      return false;
    } catch (error) {
      console.error('SecureStorage setItem error:', error);
      return false;
    }
  },

  /**
   * Get item from secure storage
   */
  getItem: (key) => {
    try {
      const encrypted = sessionStorage.getItem(key);
      if (!encrypted) return null;
      return decrypt(encrypted);
    } catch (error) {
      console.error('SecureStorage getItem error:', error);
      return null;
    }
  },

  /**
   * Remove item from secure storage
   */
  removeItem: (key) => {
    try {
      sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('SecureStorage removeItem error:', error);
      return false;
    }
  },

  /**
   * Clear all secure storage
   */
  clear: () => {
    try {
      sessionStorage.clear();
      return true;
    } catch (error) {
      console.error('SecureStorage clear error:', error);
      return false;
    }
  }
};

export default secureStorage;
